export const ERRORS = {
  EMPTY: 'empty',
  INVALID_PATTERN: 'invalid-pattern',
  INVALID_EMAIL: 'invalid-email',
} as const;

export type ValidationErrorId = typeof ERRORS[keyof typeof ERRORS];
